import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function VerifyEmail() {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('userId');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleVerify = async (e) => {
    e.preventDefault();
    if (code.length !== 6) return toast.error('Enter 6-digit code');

    setLoading(true);
    try {
      const { data } = await api.post('/auth/verify', { userId, code });
      login(data.token, data.user);
      toast.success('Email verified! Welcome to ReplyCraft!');
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      await api.post('/auth/resend-code', { userId });
      toast.success('New code sent to your email');
    } catch (err) {
      toast.error('Failed to resend code');
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={styles.iconCircle}>
            <span style={{ fontSize: 32 }}>&#9993;</span>
          </div>
          <h2 style={{ color: 'var(--text-primary)', marginBottom: 8 }}>Verify Your Email</h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>We sent a 6-digit code to your email</p>
        </div>

        <form onSubmit={handleVerify} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <input
            type="text"
            placeholder="Enter 6-digit code"
            value={code}
            onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            maxLength={6}
            style={styles.codeInput}
            autoFocus
          />

          <button type="submit" disabled={loading || code.length !== 6} style={styles.submitBtn}>
            {loading ? 'Verifying...' : 'Verify Email'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 24, color: 'var(--text-secondary)', fontSize: 14 }}>
          Didn't receive the code?{' '}
          <button onClick={handleResend} style={{ background: 'none', border: 'none', color: 'var(--accent)', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
            Resend
          </button>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-primary)', padding: 20 },
  card: { width: '100%', maxWidth: 420, background: 'var(--bg-secondary)', borderRadius: 16, padding: '40px 32px', border: '1px solid var(--border)' },
  iconCircle: { width: 64, height: 64, borderRadius: '50%', background: 'var(--accent-dim)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' },
  codeInput: {
    width: '100%', padding: 16, background: 'var(--bg-primary)', border: '1px solid var(--border)', borderRadius: 10,
    color: 'var(--text-primary)', fontSize: 24, textAlign: 'center', letterSpacing: 12, outline: 'none', fontWeight: 700
  },
  submitBtn: { padding: 14, background: 'var(--accent)', color: 'white', border: 'none', borderRadius: 10, fontSize: 16, fontWeight: 600, cursor: 'pointer' }
};
